<template>
  <div>
    <GeoImp
    class="contentWrapper"
    :checkDate="checkDate"
    :clickDate="clickDate"
    :clearSelectedDate="clearSelectedDate"
    :viewData="viewData.data"
    ></GeoImp>
    <dateTable
    :checkDate="checkDate"
    :clickDate="clickDate"
    :campaginDaysData="viewData.daysData"
    :dataInfo="viewData.data"
    tab="geo"
    ></dateTable>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'

  import GeoImp from '@/components/campaign/geo/GeoImp'
  import dateTable from '@/components/campaign/campaignBotTable/dateTable'

  export default {
    name: 'geoMain',
    components: {
      GeoImp,
      dateTable
    },
    data () {
      return {
        campaign: {},
        selectedDate: []
      }
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      checkDate (date) { // 캠페인 상세 -> 상품,사이즈,소재/ 일별 에서 선택여부 확인(상세 데이터 표시/숨김에 사용)
        return this.selectedDate.indexOf(date) > -1
      },
      clickDate (date) { // 선택한 날짜가 이미 있으면 제거, 없으면 리스트에 추가
        if (this.checkDate(date)) {
          this.selectedDate.splice(this.selectedDate.indexOf(date), 1)
          return
        }
        this.selectedDate.push(date)
      },
      clearSelectedDate () { // 탭 변경시 선택했던 날짜 정보 초기화
        this.selectedDate = []
      }
    },
    computed: {
      ...mapState({
        geoData: state => state.campaign.geoData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      viewData () {
        return {
          data: this.geoData.geo,
          daysData: this.geoData.geoAndDate
        }
      }
    },
    created () {
      this.setCampaignDetailTap('geo')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GeoMain.vue?28fe8c3c